export default __webpack_public_path__ + "static/media/ne.5a508910.svg";